import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const PromoTagCircle = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM8.27001 7.57452L7.44135 9.17248C7.12703 9.77862 7.14365 10.5032 7.48542 11.0943L10.7665 16.7688C11.3189 17.7241 12.5407 18.0515 13.4967 17.5003L16.1294 15.9826C17.0872 15.4305 17.4154 14.2059 16.862 13.2488L13.5823 7.57676C13.2412 6.98679 12.6231 6.61113 11.9424 6.57996L10.1369 6.49732C9.35783 6.46165 8.62906 6.88215 8.27001 7.57452ZM12.0816 9.04032C12.4946 9.75452 12.2529 10.6658 11.5418 11.0757C10.8306 11.4856 9.91936 11.239 9.50636 10.5248C9.09336 9.81054 9.33503 8.89926 10.0462 8.48935C10.7573 8.07943 11.6686 8.32611 12.0816 9.04032Z"
      fill="currentColor"
    />
  </Icon>
);

export default PromoTagCircle;
